<template>
  <section id="ct-home" style="width:100%;height:100%;" class="flex-col">

    <img src="@/assets/faq-logo1.png" style="position: absolute;;width:2.6rem;height:2.55rem;right: 1.03rem;top:0.32rem;">

     <img src="@/assets/invest-logo1.png" style="max-width:100%;height:8.24rem;position: absolute;left:0;top:0">

    <section style="padding:0.89rem 1.41rem" >
      <section style="width:7.18rem;">
        <h1 class="font-36" color-title><b>Frequently Asked Questions</b></h1>
        <h4 color-small-title style="margin-top:0.4rem;line-height: 1.5">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat.</h4>
      </section>

      <section style="margin-top:0.4rem;" v-for="bigBlock in helps">
        <h1 color-title style="margin-bottom: 0.3rem;">{{bigBlock.bigTitle}}</h1>

        <section class="flex-row" style="justify-content: space-between">
          <hgroup class="help-row" style="width:48%;" v-for="block in bigBlock.blocks">
            <h4 v-if="block.title" color-title>{{block.title}}</h4>
            <div @click="btnDetail(item)" class="flex-row flex-main-between" style="margin-top:0.2rem;border-bottom:1px solid rgba(0,0,0,.1); padding:10px 0;padding-right:0.1rem;min-height: .7rem;align-items: center;cursor: pointer" v-for="item in block.list">
                <h4 style="width:4.12rem;line-height: 1.5" color-small-title>{{item.title}}</h4>
                <div style="width:0.39rem;height:0.39rem;" >
                  <img src="@/assets/arrow1.png" full>
                </div>
            </div>
          </hgroup>
        </section>
      </section>

      <section style="margin-top: 0.64rem;">
        <h1 color-title>Peringatan Resiko</h1>
        <section class="flex-row" style="margin-top: 0.34rem;justify-content: space-between">
          <hgroup v-for="block in tips" class="tips" style="flex: 1">
            <h4 color-small-title v-for="tip in block" style="line-height: 1.5;">{{tip}}</h4>
          </hgroup>
        </section>
      </section>

    </section>

  </section>
</template>
<script>

import mixin from '@/plugin/mixin';

export default {
  mixins: [mixin],
  name: "help",
  computed: {
  },
  data() {
    return {
      helps:[
        { bigTitle:"Pertanyaan Umum",
          blocks:[
            { title:"Pinjaman",
              list:[
                {
                  title:"Siapa saja yang dapat mengajukan permohonan pinjaman?",
                  context:{
                    left:"AdaPundi tidak membatasi pekerjaan, pendapatan, atau kondisi Anda yang lainnya. Selama umur Anda sudah mencapai 21 tahun, memiliki pendapatan, dan nomor ponsel yang tetap, Anda dapat mengajukan pinjaman kepada AdaPundi."
                  }
                },
                {
                  title:"Bagaimana cara mengajukan pinjaman?",
                  context:{
                    left:"Silakan buka Google Play, lalu cari dan download aplikasi 'AdaPundi'. Setelah selesai, Anda dapat membuka aplikasi tersebut dan memulai proses permohonan pinjaman."
                  }
                },
                {
                  title:"Dokumen apa saja yang perlu dipersiapkan? Bagaimana proses review?",
                  context:{
                    left:"Anda hanya perlu mengikuti petunjuk yang ada pada aplikasi AdaPundi dengan mengisi 4 halaman informasi (upload foto, informasi pribadi, informasi pekerjaan dan informasi kontak). Pastikan untuk mengisi informasi asli Anda. Sistem akan secara otomatis melakukan analisa terhadap data yang Anda berikan, baik berupa kalkulasi skor kredit, skor gabungan komprehensif berdasarkan informasi yang telah Anda berikan, dan lain-lain untuk menghasilkan review pinjaman yang sesuai."
                  }
                },
              ]
            },
            {
              title:"Investasi Pinjaman",
              list:[
                {
                  title:"Bagaimana cara untuk memulai pendanaan?",
                  context:{
                    left:"Unduh aplikasi AdaPundi di Google Play Store dan daftar untuk mulai berpendanaan."
                  }
                },
                {
                  title:"Bagaimana cara memastikan keamanan dana?",
                  context:{
                    left:"Mode data besar kontrol dan sistem anti-penipuan untuk melindungi pendanaan anda."
                  }
                },
                {
                  title:"Apa manfaat berpendanaan di AdaPundi?",
                  context:{
                    left:"Tingkat bunga tahunan adalah 14%, dengan periode pendanaan yang fleksibel."
                  }
                },

              ]
            }
          ]
        },
        { bigTitle:"Pertanyaan Operasional",
          blocks:[
            { title:"",
              list:[
                {
                  title:"Apakah ketika AdaPundi memperoleh data pribadi Peminjam terkait dengan proses asesmen atau perolehan Pinjaman dari Peminjam, AdaPundi telah mematuhi ketentuan hukum yang berlaku terkait data pribadi?",
                  context:{
                    left:"AdaPundi telah mematuhi ketentuan hukum yang berlaku terkait data pribadi dengan meminta izin terlebih dahulu pada calon Peminjam yang hendak memperoleh Pinjaman dengan cara menerbitkan Kebijakan Data Privasi yang disetujui calon Peminjam sebagai syarat memperoleh Pinjaman dan mengajukan permohonan untuk mendapat Pinjaman.<br/><br/>Peminjam tidak mungkin memperoleh Pinjaman tanpa mematuhi dan terikat pada Kebijakan Data Privasi yang diterbitkan AdaPundi dan dapat dilihat Peminjam dalam akunnya di platform atau aplikasi AdaPundi. Dengan kata lain, Peminjam terikat pada Kebijakan Data Privasi ketika Peminjam memanfaatkan layanan dan jasa AdaPundi."
                  }
                },
                {
                  title:"Apakah AdaPundi dapat menghubungi keluarga, orangtua, saudara, pasangan, teman, rekan kerja atau pihak terkait Peminjam jika Peminjam gagal melunasi utang?",
                  context:{
                    left:"AdaPundi dapat menghubungi keluarga, orangtua, saudara, pasangan, teman, rekan kerja atau pihak terkait Peminjam jika Peminjam gagal melunasi utang dan terus menerus menunggak utang. Namun AdaPundi hanya akan menghubungi keluarga, orangtua, saudara, pasangan, teman, rekan kerja atau pihak terkait Peminjam yang nomor-nomornya dicantumkan sebagai Nomor Darurat oleh Peminjam saat Peminjam memohon pinjaman kepada AdaPundi.<br/><br/>Berdasarkan Kebijakan Privasi di website dan aplikasi AdaPundi, telah diatur dalam Kebijakan Data Privasi yang mengikat Peminjam, bahwa AdaPundi berhak secara hukum menghubungi keluarga, orangtua, saudara, pasangan, teman, rekan kerja atau pihak terkait Peminjam untuk meminta tolong mereka agar mengingatkan Peminjam untuk melunasi utangnya. Peminjam menjamin bahwa telah memperoleh persetujuan dari keluarga, orangtua, saudara, pasangan, teman, rekan kerja atau pihak terkait Peminjam yang dicantumkan sebagai Nomor Darurat sehingga tindakan AdaPundi menghubungi Nomor Darurat sama sekali tidak melanggar hukum dan telah memperoleh izin dari pihak yang bersangkutan."
                  }
                },
                {
                  title:"Apakah AdaPundi bertanggung jawab secara hukum terhadap adanya website , sosial media online lain yang memiliki kesamaan atau kemiripan nama dan/atau logo yang mengandung ciri dan/atau bentuk dengan website resmi AdaPundi, dalam hal ini yaitu website palsu/tiruan yang ternyata bukan dikelola AdaPundi bahkan mengandung tindak pidana atau pelanggaran hukum seperti penipuan?",
                  context:{
                    left:"AdaPundi tidak bertanggung jawab atas keberadaan dan isi website atau aplikasi yang meniru website atau aplikasi AdaPundi. Seluruh resiko dari Peminjam akibat mengakses atau memanfaatkan layanan dalam website atau aplikasi yang tidak dikelola AdaPundi tentu merupakan tanggung jawab Peminjam, tanpa dapat melibatkan AdaPundi."
                  }
                },
                {
                  title:"Apakah AdaPundi wajib bertanggung jawab atas intimidasi, kekerasan dan perbuatan melanggar hukum yang merugikan Peminjam yang disebabkan ulah oknum penagih utang eksternal yang ditugaskan AdaPundi berdasarkan kerjasama dengan penyedia jasa penagihan utang?",
                  context:{
                    left:"AdaPundi tidak bertanggung jawab atas tindakan tim penagih utang yang bukan karyawan AdaPundi. AdaPundi akan bertindak tegas dengan menyelidiki dugaan tindak kekerasan dan intimidasi oleh penagih utang dari perusahaan yang bekerjasama dengan AdaPundi untuk menagih utang Peminam. Jika terbukti bersalah, maka AdaPundi akan mengakhiri kerjasama dengan perusahaan penyedia jasa penagih utang tersebut."
                  }
                },
                {
                  title:"Apa upaya pencegahan dan penanggulangan yang akan dilakukan AdaPundi apabila ada penagih utang yang bukan berasal dan bukan merupakan perwakilan atau petugas dari AdaPundi, namun malah mengaku-ngaku sebagai karyawan AdaPundi?",
                  context:{
                    left:"AdaPundi tidak bertanggung jawab atas ulah dan tindakan intimidasi dan kekerasan serta pelanggaran hukum yang dilakukan oleh oknum penagih utang gelap, palsu atau yang mengaku-ngaku sebagai karyawan AdaPundi padahal kenyataannya tidak demikian.<br/><br/>Peminjam perlu menjelaskan mengenai identitas tim penagih utang yang mengaku-ngaku sebagai karyawan AdaPundi agar AdaPundi dapat melakukan penyelidikan dan pengecekan. Jika terbukti oknum tersebut bukan karyawan AdaPundi, maka AdaPundi tidak bertanggung jawab atas kerugian Peminjam."
                  }
                },

              ]
            },

          ]
        }
      ],
      tips:[
        [
          "1. Layanan Pinjam Meminjam Berbasis Teknologi Informasi merupakan kesepakatan perdata antara Pemberi Pinjaman dengan Penerima Pinjaman, sehingga segala risiko yang timbul dari kesepakatan tersebut ditanggung sepenuhnya oleh masing-masing pihak.",

          "2. Risiko kredit atau gagal bayar ditanggung sepenuhnya oleh Pemberi Pinjaman. Tidak ada lembaga atau otoritas negara yang bertanggung jawab atas risiko gagal bayar ini.",

          "3. Penyelenggara dengan persetujuan dari masing-masing Pengguna (Pemberi Pinjaman dan/atau Penerima Pinjaman) mengakses, memperoleh, menyimpan, mengelola dan/atau menggunakan data pribadi Pengguna (“Pemanfaatan Data”) pada atau di dalam benda, perangkat elektronik (termasuk smartphone atau telepon seluler), perangkat keras (hardware) maupun lunak (software), dokumen elektronik, aplikasi atau system elektronik milik Pengguna atau yang dikuasai Pengguna, dengan memberitahukan tujuan, batasan dan mekanisme Pemanfaatan Data tersebut kepada Pengguna yang bersangkutan sebelum memperoleh persetujuan yang dimaksud.",

          "4. Pemberi Pinjaman yang belum memiliki pengetahuan dan pengalaman pinjam meminjam, disarankan untuk tidak menggunakan layanan ini.",

          "5. Penerima Pinjaman harus mempertimbangkan tingkat bunga pinjaman dan biaya lainnya sesuai dengan kemampuan dalam melunasi pinjaman."
        ],
        [
          "6. Setiap kecurangan tercatat secara digital di dunia maya dan dapat diketahui masyarakat luas di media sosial.",

          "7. Pengguna harus membaca dan memahami informasi ini sebelum membuat keputusan menjadi Pemberi Pinjaman atau Penerima Pinjaman.",

          "8. Pemerintah yaitu dalam hal ini Otoritas Jasa Keuangan, tidak bertanggung jawab atas setiap pelanggaran atau ketidakpatuhan oleh Pengguna, baik Pemberi Pinjaman maupun Penerima Pinjaman (baik karena kesengajaan atau kelalaian Pengguna) terhadap ketentuan peraturan perundang-undangan maupun kesepakatan atau perikatan antara Penyelenggara dengan Pemberi Pinjaman dan/atau Penerima Pinjaman.",

          "9. Setiap transaksi dan kegiatan pinjam meminjam atau pelaksanaan kesepakatan mengenai pinjam meminjam antara atau yang melibatkan Penyelenggara, Pemberi Pinjaman dan/atau Penerima Pinjaman wajib dilakukan melalui escrow account dan virtual account sebagaimana yang diwajibkan berdasarkan Peraturan Otoritas Jasa Keuangan Nomor 77/POJK.01/2016 tentang Layanan Pinjam Meminjam Uang Berbasis Teknologi Informasi dan pelanggaran atau ketidakpatuhan terhadap ketentuan tersebut merupakan bukti telah terjadinya pelanggaran hukum oleh Penyelenggara sehingga Penyelenggara wajib menanggung ganti rugi yang diderita oleh masingmasing Pengguna sebagai akibat langsung dari pelanggaran hukum tersebut di atas tanpa mengurangi hak Pengguna yang menderita kerugian menurut Kitab Undang-Undang Hukum Perdata.",
        ]
      ],
      bottomTabIndex: 0,
    };
  },
  methods: {
    btnDetail(item){
      this.$popupHelp.open(item.title,item.context.left,item.context.right)
    }
  },
  components: {

  }
};

</script>

<style scoped lang="scss">
.tips{
  margin-left:0.2rem;
  h4{
    margin-top:0.3rem;
  }
  h4:first-child{margin-top:0;}

}
.tips:first-child{
  margin-left:0;
}
.help-row{
  margin-left:0.1rem;
  & > h4:first-child:before{
    content: '';
    width:0.04rem;height:0.04rem;
    background:#06A789;
    border-radius:50%;
    position: absolute;
    left:-0.13rem;
    top:0.06rem;

  }
}
.help-row:first-child{
  margin-left:0;
}
</style>
